import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/my-students-courses`;

export const myStudentsCoursesRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:courseId`,
  viewOnlineExamScore: `${baseRoute}/:courseId/view/:examId/online/score/:attemptId`,
  viewDescriptiveExamScore: `${baseRoute}/:courseId/view/:examId/descriptive/score/:attemptId`,
  editDescriptiveExamScore: `${baseRoute}/:courseId/edit/:examId/descriptive/score/:attemptId`,
} as const;

export type IMyStudentsCoursesRouteParams = IExtractRouteParamMap<
  typeof myStudentsCoursesRoutesObj
>;

export const myStudentsCoursesPath = createPaths<
  typeof myStudentsCoursesRoutesObj,
  IMyStudentsCoursesRouteParams
>(myStudentsCoursesRoutesObj);
